export default __webpack_public_path__ + "static/media/oph_1_jm_r_1.83ff16a6.png";